
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 640 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M436.6 429.6C407.4 460.6 366 480 320 480c-88.4 0-160-71.6-160-160 0-18.5 8.9-46 26.5-80.1.9-1.8 1.9-3.7 2.9-5.5l-25.5-20.1C142.6 253.2 128 290.7 128 320c0 106 86 192 192 192 56.2 0 106.7-24.1 141.8-62.5zM298.9 24.4C282.6 43.8 258.7 73 234 106.5l25.1 19.8c20.3-27.6 40.1-52.3 55.5-70.9 1.9-2.2 3.6-4.4 5.4-6.4 1.7 2.1 3.5 4.2 5.4 6.4 17.7 21.3 41.2 50.8 64.7 83.4 23.5 32.7 46.5 68 63.5 101 11.6 22.6 19.5 42.4 23.4 58.5l34.9 27.7c.1-2 .1-4 .1-6 0-84.2-121-236.4-170.9-295.6C328.2 9.1 320 0 320 0s-8.2 9.1-21.1 24.4zM320 400c-44.2 0-80-35.8-80-80h-32c0 61.9 50.1 112 112 112zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8 579.1 451.1 12.6 9.8 19.7-25.2-12.6-9.9z"}})])
          )
        }
      }
    